import { BadgeCheck, CirclePlus } from "lucide-react";
import { Reveal, SectionHeading } from "./Reveal";
import { BRANDS, BRANDS_INTRO, BRANDS_NOTE } from "../data/site";

export const BrandStrip = () => (
  <section id="markak" data-testid="brands-section" className="scroll-mt-24 py-24 sm:py-28">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionHeading
        eyebrow={BRANDS_INTRO.eyebrow}
        title={BRANDS_INTRO.title}
        sub={BRANDS_INTRO.text}
      />

      <div className="mt-12 grid gap-5 md:grid-cols-3">
        {BRANDS.map((brand, i) => (
          <Reveal key={brand.name} delay={i * 0.08}>
            <div
              data-testid={`brand-card-${brand.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="h-full rounded-3xl border border-line bg-white p-8 card-shadow"
            >
              <div className="flex h-16 items-center">
                <img
                  src={brand.logo}
                  alt={brand.alt}
                  loading="lazy"
                  className="max-h-14 w-auto object-contain"
                />
              </div>
              <p className="mt-6 flex items-center gap-1.5 text-[11px] font-extrabold uppercase tracking-[0.16em] text-burgundy">
                <BadgeCheck className="h-3.5 w-3.5" /> {brand.badge}
              </p>
              <h3 className="mt-2 font-display text-2xl font-semibold text-ink">{brand.name}</h3>
              <p className="mt-2 text-sm leading-relaxed text-soft">{brand.desc}</p>
            </div>
          </Reveal>
        ))}
      </div>

      <Reveal delay={0.15}>
        <div
          data-testid="brands-more-note"
          className="mt-6 flex items-start gap-4 rounded-3xl border border-dashed border-line bg-cream2 p-6"
        >
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-2xl bg-burgundy/10 text-burgundy">
            <CirclePlus className="h-5 w-5" />
          </span>
          <p className="text-sm leading-relaxed text-soft sm:text-base">{BRANDS_NOTE}</p>
        </div>
      </Reveal>
    </div>
  </section>
);
